export var AvailabilityRequestsEmployerRoutes = {
    "/availability-requests?start_date&status&user_id&mode": {
        "loginRequired": true,
        "name": "appLayout.schedule.availability-requests",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "availabilityRequestsEmployerContainer"
            }
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "params": {
            start_date: {dynamic: true},
            status: {dynamic: true},
            user_id: {dynamic: true}
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./availability-requests-shared.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../employment-types/employment-types.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("./availability-requests-employer.module.js");
                }
            },
        ],
        "onEnter": ['hUser', 'userPermissions', function (hUser, userPermissions) {
            userPermissions.getBrandPolicy(hUser.getUserContext().brand_id)
                .then(function (policyParser) {
                    var hasAccessToTeam = policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM);
                    if (!hUser.isTeamSchedulingEnabled() && !hasAccessToTeam) {
                        hRedirect('/dashboard');
                    }
                });
        }],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["availability_requests", "availability_requests_shared"]
        }
    }
};
